import { FeatureService } from './../../../../../core/services/feature/feature.service';
import { MatSort, MatSortable } from '@angular/material/sort';
import { Permission } from '../../master-visualizar-perfil.model';
import { Component, Input, OnInit, ViewChild, OnChanges } from '@angular/core';
import { uniqBy } from 'lodash';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-master-visualizar-perfil-permissoes',
  templateUrl: './master-visualizar-perfil-permissoes.component.html',
  styleUrls: ['./master-visualizar-perfil-permissoes.component.scss'],
})
export class MasterVisualizarPerfilPermissoesComponent
  implements OnInit, OnChanges {
  @Input() set permissions(permission: Permission[]) {
    permission.forEach(element=>{
      element.namePermission = this.featureService.translatorService.translateEnumItem(element.namePermission,'PermissionsType')
    })
    this.permissionsDS = new MatTableDataSource<Permission>(
      uniqBy(permission, 'namePermission').naturalSort(['namePermission']),  
    );
  }

  permissionsDS: MatTableDataSource<Permission>;

  permissionsFilter: any;
  permissionsComplete: any;
  @ViewChild('sortPermissions', { static: true }) sortPermissions: MatSort;

  columns = ['namePermission'];

  constructor(private featureService:FeatureService) { }

  ngOnInit() {
    this.sortPermissions.sort({
      id: 'namePermission',
      start: 'asc',
    } as MatSortable);
    this.sortPermissions.disableClear = true;
  }

  ngOnChanges() {
    this.permissionsDS.sort = this.sortPermissions;
  }
  filterPermissions(event?: Event) {
    this.permissionsDS.filterPredicate = (data, filter) => {
      data.namePermission = this.featureService.translatorService.translateEnumItem(data.namePermission,'PermissionsType')
      return data.namePermission.toLowerCase().includes(filter.toLowerCase());
    };
    this.permissionsFilter = (event.target as HTMLInputElement).value;
    this.permissionsDS.filter = this.permissionsFilter;

    if (
      this.permissionsFilter.length > 0 &&
      this.permissionsFilter.length % 2 == 0
    ) {
      this.permissionsComplete = this.permissionsDS.filteredData;
    } else if (this.permissionsFilter.length == 0) {
      this.permissionsComplete = [];
    }
  }
}
